import { useState } from "react";

function ChatInput({ onSend, disabled }) {
  const [inputValue, setInputValue] = useState("");

  const submitQuestion = () => {
    const question = inputValue.trim();
    if (!question || disabled) return;
    onSend(question);
    setInputValue("");
  };

  const onKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      submitQuestion();
    }
  };

  return (
    <div className="chat-input-wrapper">
      <input
        type="text"
        className="chat-input-field"
        value={inputValue}
        onChange={(event) => setInputValue(event.target.value)}
        onKeyDown={onKeyDown}
        placeholder="Ask anything..."
        disabled={disabled}
        autoComplete="off"
      />
      <button
        type="button"
        className="chat-send-button"
        onClick={submitQuestion}
        disabled={disabled || !inputValue.trim()}
        aria-label="Send message"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M4.5 19.5L20.25 12L4.5 4.5L4.491 10.333L15.75 12L4.491 13.667L4.5 19.5Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
  );
}

export default ChatInput;
